import React, { useEffect, useState, useRef } from "react";
import MainLayout from "../nav/MainLayout";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import TotalValue from "../data/TotalData.json";
import logoImg from "../../assets/img/tick-mark.png";

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import Login from "../auth/Login.jsx";
import { Details } from "../PageLayout/Dashboard/Details.jsx";
import { Button } from "react-bootstrap";
import { FaMailBulk, FaMailchimp } from "react-icons/fa";
import axios from "axios";
import { Alert } from "@mui/material";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));

export default function Dashboard() {
  const [data, setData] = useState(TotalValue);
  const [isLoading, setIsloading] = useState(false);
  const [issuccess, setsuccess] = useState(false);
  const [iserror, seterror] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  const name = urlParams.get("name");
  const details = urlParams.get("details");
  const vendorname = urlParams.get("particulars");
  const node = urlParams.get("node");

  console.log(name);
  console.log(details);
  console.log(vendorname);
  console.log(node);

  const validateDate =
    data && data.filter((item) => item.PrimaryType === `${details}`);

  const validateSecLayer =
    validateDate &&
    validateDate.filter((item) => item.SecondaryType === `${node}`);

  const validateModuleName =
    validateSecLayer &&
    validateSecLayer.filter((item) => item.ModuleName === `${name}`);

  const validateParticularName =
    validateModuleName &&
    validateModuleName.filter((item) => item.Particulars === `${vendorname}`);

  const TestData = validateParticularName
    ? { ...validateParticularName }
    : null;
  console.log("TestData", TestData[0]);

  const totalMargin =
    validateModuleName &&
    validateModuleName.reduce(
      (sum, item) => sum + parseFloat(item.TotalValue),
      0
    );

  const sendEmail = async () => {
    setIsloading(true);
    const url =
      "https://prod-73.eastus.logic.azure.com:443/workflows/2abb39b1de0d4000a7a0e2d380517a2f/triggers/When_a_HTTP_request_is_received/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun&sv=1.0&sig=bJVxcVDv2rykNTEny96uSuIhLoiI_dkmBEx-TkW0D5k";
    const dataItem = {
      To: "nabasundarr@aaysinsight.com,anshuman.bhar@aaysanalytics.com,dwarika.patro@aaysinsight.com",
      Subject: `${TestData[0].Status} for Particulars ${TestData[0].Particulars} on Module ${TestData[0].ModuleName}`,
      email_body: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
        <html xmlns="http://www.w3.org/1999/xhtml"> 
        <head>
            <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1">
            <title>Responsive HTML Email Template</title>
            <style type="text/css">
                /* reset */
                article,
                aside,
                details,
                figcaption,
                figure,
                footer,
                header,
                hgroup,
                nav,
                section,
                summary {
                    display: block
                }
        
                audio,
                canvas,
                video {
                    display: inline-block;
                    display: inline;
                    zoom: 1
                }
        
                audio:not([controls]) {
                    display: none;
                    height: 0
                }
        
                [hidden] {
                    display: none
                }
        
                html {
                    font-size: 100%;
                    -webkit-text-size-adjust: 100%;
                    -ms-text-size-adjust: 100%
                }
        
                html,
                button,
                input,
                select,
                textarea {
                    font-family: sans-serif
                }
        
                body {
                    margin: 0
                }
        
                a:focus {
                    outline: thin dotted
                }
        
                a:active,
                a:hover {
                    outline: 0
                }
        
                h1 {
                    font-size: 2em;
                    margin: 0 0.67em 0
                }
        
                h2 {
                    font-size: 1.5em;
                    margin: 0 0 .83em 0
                }
        
                h3 {
                    font-size: 1.17em;
                    margin: 1em 0
                }
        
                h4 {
                    font-size: 1em;
                    margin: 1.33em 0
                }
        
                h5 {
                    font-size: .83em;
                    margin: 1.67em 0
                }
        
                h6 {
                    font-size: .75em;
                    margin: 2.33em 0
                }
        
                abbr[title] {
                    border-bottom: 0px dotted
                }
        
                b,
                strong {
                    font-weight: bold
                }
        
                blockquote {
                    margin: 1em 40px
                }
        
                dfn {
                    font-style: italic
                }
        
                mark {
                    background: #ff0;
                    color: #000
                }
        
                p,
                pre {
                    margin: 1em 0
                }
        
                code,
                kbd,
                pre,
                samp {
                    font-family: monospace, serif;
                    _font-family: 'courier new', monospace;
                    font-size: 1em
                }
        
                pre {
                    white-space: pre;
                    white-space: pre-wrap;
                    word-wrap: break-word
                }
        
                q {
                    quotes: none
                }
        
                q:before,
                q:after {
                    content: '';
                    content: none
                }
        
                small {
                    font-size: 75%
                }
        
                sub,
                sup {
                    font-size: 75%;
                    line-height: 0;
                    position: relative;
                    vertical-align: baseline
                }
        
                sup {
                    top: -0.5em
                }
        
                sub {
                    bottom: -0.25em
                }
        
                dl,
                menu,
                ol,
                ul {
                    margin: 1em 0
                }
        
                dd {
                    margin: 0 0 0 40px
                }
        
                menu,
                ol,
                ul {
                    padding: 0 0 0 40px
                }
        
                nav ul,
                nav ol {
                    list-style: none;
                    list-style-image: none
                }
        
                img {
                    border: 0;
                    -ms-interpolation-mode: bicubic
                }
        
                svg:not(:root) {
                    overflow: hidden
                }
        
                figure {
                    margin: 0
                }
        
                form {
                    margin: 0
                }
        
                fieldset {
                    border: 1px solid #c0c0c0;
                    margin: 0 2px;
                    padding: .35em .625em .75em
                }
        
                legend {
                    border: 0;
                    padding: 0;
                    white-space: normal;
                    margin-left: -7px
                }
        
                button,
                input,
                select,
                textarea {
                    font-size: 100%;
                    margin: 0;
                    vertical-align: baseline;
                    vertical-align: middle
                }
        
                button,
                input {
                    line-height: normal
                }
        
                button,
                html input[type="button"],
                input[type="reset"],
                input[type="submit"] {
                    -webkit-appearance: button;
                    cursor: pointer;
                    overflow: visible
                }
        
                button[disabled],
                input[disabled] {
                    cursor: default
                }
        
                input[type="checkbox"],
                input[type="radio"] {
                    box-sizing: border-box;
                    padding: 0;
                    height: 13px;
                    width: 13px
                }
        
                input[type="search"] {
                    -webkit-appearance: textfield;
                    -moz-box-sizing: content-box;
                    -webkit-box-sizing: content-box;
                    box-sizing: content-box
                }
        
                input[type="search"]::-webkit-search-cancel-button,
                input[type="search"]::-webkit-search-decoration {
                    -webkit-appearance: none
                }
        
                button::-moz-focus-inner,
                input::-moz-focus-inner {
                    border: 0;
                    padding: 0
                }
        
                textarea {
                    overflow: auto;
                    vertical-align: top
                }
        
                table {
                    border-collapse: collapse;
                    border-spacing: 0
                }
        
                /* custom client-specific styles including styles for different online clients */
                .ReadMsgBody {
                    width: 100%;
                }
        
                .ExternalClass {
                    width: 100%;
                }
        
                /* hotmail / outlook.com */
                .ExternalClass,
                .ExternalClass p,
                .ExternalClass span,
                .ExternalClass font,
                .ExternalClass td,
                .ExternalClass div {
                    line-height: 100%;
                }
        
                /* hotmail / outlook.com */
                table,
                td {
                    mso-table-lspace: 0pt;
                    mso-table-rspace: 0pt;
                }
        
                /* Outlook */
                #outlook a {
                    padding: 0;
                }
        
                /* Outlook */
                img {
                    -ms-interpolation-mode: bicubic;
                    display: block;
                    outline: none;
                    text-decoration: none;
                }
        
                /* IExplorer */
                body,
                table,
                td,
                p,
                a,
                li,
                blockquote {
                    -ms-text-size-adjust: 100%;
                    -webkit-text-size-adjust: 100%;
                    font-weight: normal !important;
                }
        
                .ExternalClass td[class="ecxflexibleContainerBox"] h3 {
                    padding-top: 10px !important;
                }
        
                /* hotmail */
        
                /* email template styles */
                h1 {
                    display: block;
                    font-size: 26px;
                    font-style: normal;
                    font-weight: normal;
                    line-height: 100%;
                }
        
                h2 {
                    display: block;
                    font-size: 20px;
                    font-style: normal;
                    font-weight: normal;
                    line-height: 120%;
                }
        
                h3 {
                    display: block;
                    font-size: 17px;
                    font-style: normal;
                    font-weight: normal;
                    line-height: 110%;
                }
        
                h4 {
                    display: block;
                    font-size: 18px;
                    font-style: italic;
                    font-weight: normal;
                    line-height: 100%;
                }
        
                .flexibleImage {
                    height: auto;
                }
        
                table[class=flexibleContainerCellDivider] {
                    padding-bottom: 0 !important;
                    padding-top: 0 !important;
                }
        
                body,
                #bodyTbl {
                    background-color: #FFFFFF;
                }
        
                #emailHeader {
                    background-color: #E1E1E1;
                }
        
                #emailBody {
                    background-color: #FFFFFF;
                }
        
                #emailFooter {
                    background-color: #E1E1E1;
                }
        
                .textContent {
                    color: #8B8B8B;
                    font-family: Helvetica;
                    font-size: 16px;
                    line-height: 125%;
                    text-align: Left;
                }
        
                .textContent a {
                    color: #205478;
                    text-decoration: underline;
                }
        
                .emailButton {
                    background-color: #205478;
                    border-collapse: separate;
                }
        
                .buttonContent {
                    color: #FFFFFF;
                    font-family: Helvetica;
                    font-size: 18px;
                    font-weight: bold;
                    line-height: 100%;
                    padding: 15px;
                    text-align: center;
                }
        
                .buttonContent a {
                    color: #FFFFFF;
                    display: block;
                    text-decoration: none !important;
                    border: 0 !important;
                }
        
                #invisibleIntroduction {
                    display: none;
                    display: none !important;
                }
        
                /* hide the introduction text */
        
                /* other framework hacks and overrides */
                span[class=ios-color-hack] a {
                    color: #275100 !important;
                    text-decoration: none !important;
                }
        
                /* Remove all link colors in IOS (below are duplicates based on the color preference) */
                span[class=ios-color-hack2] a {
                    color: #205478 !important;
                    text-decoration: none !important;
                }
        
                span[class=ios-color-hack3] a {
                    color: #8B8B8B !important;
                    text-decoration: none !important;
                }
        
                /* phones and sms */
                .a[href^="tel"],
                a[href^="sms"] {
                    text-decoration: none !important;
                    color: #606060 !important;
                    pointer-events: none !important;
                    cursor: default !important;
                }
        
                .mobile_link a[href^="tel"],
                .mobile_link a[href^="sms"] {
                    text-decoration: none !important;
                    color: #606060 !important;
                    pointer-events: auto !important;
                    cursor: default !important;
                }
        
                /* responsive styles */
                @media only screen and (max-width: 767px) {
                    body {
                        width: 100% !important;
                        min-width: 100% !important;
                    }
        
                    table[id="emailHeader"],
                    table[id="emailBody"],
                    table[id="emailFooter"],
                    table[class="flexibleContainer"] {
                        width: 100% !important;
                    }
        
                    td[class="flexibleContainerBox"],
                    td[class="flexibleContainerBox"] table {
                        display: block;
                        width: 100%;
                        text-align: left;
                    }
        
                    td[class="imageContent"] img {
                        height: auto !important;
                        width: 100% !important;
                        max-width: 100% !important;
                    }
        
                    img[class="flexibleImage"] {
                        height: auto !important;
                        width: 100% !important;
                        max-width: 100% !important;
                    }
        
                    img[class="flexibleImageSmall"] {
                        height: auto !important;
                        width: auto !important;
                    }
        
                    table[class="flexibleContainerBoxNext"] {
                        padding-top: 10px !important;
                    }
        
                    table[class="emailButton"] {
                        width: 100% !important;
                    }
        
                    td[class="buttonContent"] {
                        padding: 0 !important;
                    }
        
                    td[class="buttonContent"] a {
                        padding: 15px !important;
                    }
                }
        
                a {
                    text-decoration: none !important;
                }
        
                td,
                tr,
                table {
                    border-color: transparent !important;
                }
        
                .rps_eb72 a:link {
                    text-decoration: none !important;
                }
        
                .rps_eb72 a:link,
                .rps_eb72 span.x_MsoHyperlink {
                    text-decoration: none !important;
                }
        
        
                .ii a[href] {
                    text-decoration:
                        none;
                    color:
                        inherit !important;
                }
        
                .link-nostyle {
                    color:
                        inherit;
                    text-decoration:
                        none
                }
        
                .link-underlined {
                    color:
                        inherit;
                    text-decoration:
                        none !important;
                }
        
                .link-underlined span {
                    text-decoration:
                        none !important;
                }
        
                .link-not-underlined {
                    color:
                        inherit;
                    text-decoration:
                        none !important;
                    text-decoration-color:
                        transparent;
                    color:
                        green;
                }
        
                .myClass a {
                    text-decoration: none;
                }
            </style>
            <!--
              MS Outlook custom styles
            -->
            <!--[if mso 12]>
              <style type="text/css">
                .flexibleContainer{display:block !important; width:100% !important;}
                a {text-decoration: none;}
        
              </style>
            <![endif]-->
            <!--[if mso 14]>
              <style type="text/css">
                .flexibleContainer{display:block !important; width:100% !important;}
                a {text-decoration: none;}
        
              </style>
            <![endif]-->
            <!--[if (mso)|(mso 16)]>
        <style type="text/css">
        a {text-decoration: none;}
        
        </style>
        <![endif]-->
            <!--[if (gte mso 9)|(IE)]>
        <style type="text/css">
        a{
        font-weight: normal !important;
        text-decoration: none !important;
        }
        </style>
        <![endif]-->
        
        
        </head>
        
        <body bgcolor="#FFFFFF" leftmargin="0" marginwidth="0" topmargin="0" marginheight="0" offset="0">
            <center style="background-color:#FFFFFF;">
                <table border="0" cellpadding="0" cellspacing="0" height="100%" width="100%" id="bodyTbl"
                    style="table-layout: fixed;max-width:100% !important;width: 100% !important;min-width: 100% !important;">
                    <tr>
                        <td align="center" valign="top" id="bodyCell">
        
        
        
                            <table bgcolor="#FFFFFF" border="0" cellpadding="0" cellspacing="0" width="800" id="emailBody">
        
                             
        
                                <!-------------About teams and outlook ------------------>
        
                               
        
                                <tr>
                                    <td align="center" valign="top">
                                        <table bgcolor="#F1F7FC" border="0" cellpadding="0" cellspacing="0" width="100%">
                                            <tr>
                                                <td align="center" valign="top">
                                                    <table border="0" cellpadding="30" cellspacing="0" width="800"
                                                        class="flexibleContainer">
                                                        <tr>
                                                            <td valign="top" width="800" class="flexibleContainerCell">
        
                                                                <table align="left" border="0" cellpadding="0" cellspacing="0"
                                                                    width="100%">
                                                                    <tr>
        
        
                                                                        <td align="left" valign="center" class="flexibleContainerBox">
                                                                            <table class="flexibleContainerBoxNext" border="0" cellpadding="0" cellspacing="0" style="max-width:100%;">
                                                                                <tr>
                                                                                    <td align="left">
                                                                                        <table role="presentation" cellspacing="0" cellpadding="0" border="0">
                                                                                            <tr>
                                                                                          
                                                                                                <td align="left" class="textContent" style="color: #0C2744; font-family: Arial, sans-serif;">
                                                                                                    Dear <span style="font-weight: 600; text-transform: capitalize;">Anshuman</span>,
                                                                                                </td>
                                                                                            </tr>
                                                                                        </table>
                                                                                    </td>
                                                                                </tr>
                                                                        
                                                                                <tr>
                                                                                    <td height="10px"></td>
                                                                                </tr>
                                                                        
                                                                                <tr>
                                                                                    <td align="left">
                                                                                        <table role="presentation" cellspacing="0" cellpadding="0" border="0">
                                                                                            <tr>
                                                                                                <td align="left" class="textContent" style="color: #0C2744; font-family: Arial, sans-serif;">
                                                                                                    

                                                                                                    <b> Module Name:</b> ${TestData[0].ModuleName}

                                                                                                </td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td height="10px"></td>
                                                                                            </tr>                                                                                            <tr>
                                                                                                <td align="left" class="textContent" style="color: #0C2744; font-family: Arial, sans-serif;">
                                                                                                    <b> Particulars:</b>   ${TestData[0].Particulars}
                                                                                                </td>
                                                                                            </tr>

                                                                                            <tr>
                                                                                                <td height="10px"></td>
                                                                                            </tr>                                                                                            <tr>
                                                                                                <td align="left" class="textContent" style="color: #0C2744; font-family: Arial, sans-serif;">
                                                                                                    <b> KeyInsights:</b>    ${TestData[0].KeyInsights}
                                                                                                </td>
                                                                                            </tr>

                                                                                            <tr>
                                                                                                <td height="10px"></td>
                                                                                            </tr>                                                                                            <tr>
                                                                                                <td align="left" class="textContent" style="color: #0C2744; font-family: Arial, sans-serif;">
                                                                                                    <b> Recommendations:</b>  ${TestData[0].Recommendations}
                                                                                                </td>
                                                                                            </tr>

                                                                                            <tr>
                                                                                                <td height="10px"></td>
                                                                                            </tr>                                                                                            <tr>
                                                                                                <td align="left" class="textContent" style="color: #0C2744; font-family: Arial, sans-serif;">
                                                                                                    <b>Status:</b> ${TestData[0].Status}
                                                                                                </td>
                                                                                            </tr>
                                                                                        </table>
                                                                                    </td>
                                                                                </tr>
                                                                        
                                                                                <tr>
                                                                                    <td height="15px"></td>
                                                                                </tr>
                                                                        
                                                                                <!-- View Response Button -->
                                                                                <tr>
                                                                                    <td>
                                                                                        <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                                                                                            <tr>
                                                                                
                                                                                                <td style="background-color: #0000a0; padding: 10px 20px; border-radius: 5px; width: calc(100% - 60px);">
                                                                                                   <a href="https://cfo.infotechhub.co.in/dashboard?name=${TestData[0].ModuleName}&details=${TestData[0].PrimaryType}&particulars=${TestData[0].Particulars}&node=${TestData[0].SecondaryType}" 
                                                                                                       style="color: #ffffff; text-decoration: none; font-family: Arial, sans-serif; font-weight: bold; display: block; text-align: center;">
                                                                                                    Click here to view
                                                                                                  </a>

                                                                                                </td>
                                                                                            </tr>
                                                                                        </table>
                                                                                    </td>
                                                                                </tr>

                                                                                <tr>
                                                                                    <td height="15px"></td>
                                                                                </tr>
                                                                                
                                                                                <tr>
                                                                                    <td align="left">
                                                                                        <table role="presentation" cellspacing="0" cellpadding="0" border="0">
                                                                                            <tr>
                                                                                                <td align="left" class="textContent" style="color: #0C2744; font-family: Arial, sans-serif;">
                                                                                                    In case of any discrepancy, kindly write to <i style="color: #0000a0;"> support@aaysinsight.com</i> or you can resubmit the details at form.                                                                                                </td>
                                                                                            </tr>
                                                                                        </table>
                                                                                    </td>
                                                                                </tr>
                                                                                
                                                                        
                                                                            </table>
                                                                        </td>
                                                                        
        
        
                                                                    </tr>
                                                                </table>
        
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
        
        
        
        
        
        
           
        
        
        
                </table>
        
       
        
                </td>
                </tr>
                </table>
            </center>
        </body>
        
        </html>`,
    };

    axios
      .post(url, dataItem)

      .then(function (response) {
        if (response.status === 202) {
          // console.log(response);
          setIsloading(false);
          setsuccess(true);
          setTimeout(() => {
            setsuccess(false);
          }, 5000);
        }
      })
      .catch(function (error) {
        // console.log(error);
        setIsloading(false);
        seterror(true);
        setTimeout(() => {
          seterror(false);
        }, 5000);
      });
  };

  return (
    <>
      <AuthenticatedTemplate>
        <div id="homePage" style={{ overflow: "hidden", position: "relative" }}>
          <Box
            className="mainLayout"
            sx={{ display: "flex", overflow: "hidden" }}
          >
            <MainLayout />

            <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
              <DrawerHeader />
              <DrawerHeader style={{ minHeight: "0px", paddingTop: "3px" }} />

              <div id="mainHome" style={{ overflowY: "auto" }}>
                <div>
                  <div
                    style={{
                      padding: "14px",
                      fontSize: "14px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {/* <a href="/">Home </a>/ <a href="/details">Improve Margin</a> / Revenue */}
                    <span>
                      <a href="/">Home</a> /{" "}
                      <a href={`/details?name=${details}`}>{details}</a> /{" "}
                      <a href={`/details?name=${details}`}>{node}</a> /{" "}
                      <a
                        href={`/summary?name=${name}&&details=${details}&&node=${node}`}
                      >
                        {name}
                      </a>{" "}
                      / {vendorname}
                    </span>

                    <span style={{ display: "flex", gap: "10px" }}>
                      <Button disabled={isLoading} onClick={sendEmail}>
                        {isLoading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          </>
                        ) : (
                          <FaMailBulk />
                        )}
                      </Button>
                      <Button
                        style={{ background: "green", borderColor: "green" }}
                      >
                        Accept
                      </Button>
                      <Button
                        style={{
                          background: "#990d0d",
                          borderColor: "#990d0d",
                        }}
                      >
                        Reject
                      </Button>
                      <Button
                        style={{
                          background: "#ca5733",
                          borderColor: "#ca5733",
                        }}
                      >
                        Amend
                      </Button>
                    </span>
                  </div>
                  {validateParticularName &&
                    validateParticularName.length !== 0 &&
                    validateParticularName.map((item, index) => {
                      return (
                        <div key={index}>
                          <Details dataItem={item} totalMargin={totalMargin} />
                        </div>
                      );
                    })}
                  {/* <PowerBiReport/> */}
                </div>
              </div>
            </Box>
          </Box>
        </div>

        {issuccess && (
          <div style={{ position: "fixed", right: "10px", bottom: "2%" }}>
            <Alert severity="success">
              Email Trigger Successfully Executed
            </Alert>
          </div>
        )}

        {iserror && (
          <div style={{ position: "fixed", right: "10px", bottom: "2%" }}>
            <Alert severity="error">
              Something went wrong, Please try after sometime
            </Alert>
          </div>
        )}
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
}
